module.exports = __webpack_public_path__ + "amcharts/images/xIconH.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/xIconH.svg
// module id = 287
// module chunks = 0